import { apiClient } from './apiClient';
import {
  Deal,
  AcceptDealPayload,
  RejectDealPayload,
  PaginatedResponse,
  CreateRatingPayload,
  Rating,
} from '../types';

export const dealService = {
  async list(params?: {
    status?: string;
    page?: number;
  }): Promise<PaginatedResponse<Deal>> {
    const { data } = await apiClient.get<PaginatedResponse<Deal>>('/deals/', { params });
    return data;
  },

  async getDetail(id: string): Promise<Deal> {
    const { data } = await apiClient.get<Deal>(`/deals/${id}/`);
    return data;
  },

  async accept(dealId: string, payload: AcceptDealPayload): Promise<Deal> {
    const { data } = await apiClient.post<Deal>(`/deals/${dealId}/accept/`, payload);
    return data;
  },

  async reject(dealId: string, payload: RejectDealPayload): Promise<Deal> {
    const { data } = await apiClient.post<Deal>(`/deals/${dealId}/reject/`, payload);
    return data;
  },

  async unreject(dealId: string): Promise<Deal> {
    const { data } = await apiClient.post<Deal>(`/deals/${dealId}/unreject/`);
    return data;
  },

  async createRating(payload: CreateRatingPayload): Promise<Rating> {
    const { data } = await apiClient.post<Rating>('/ratings/', payload);
    return data;
  },
};
